<template lang="html">
  <div class="report-controls">
    <div class="report-controls-cluster">
      <report-filter
        :deliverable-types="deliverableTypes"
        :type-index="typeIndex"
        :selected-deliverable-types="selectedDeliverableTypes"
        :colors="colors"
        @change="reportFilterChanged"
      />

      <dropdown
        v-if="tags.length > 0"
        class="menu-drop button basic floating control-drop"
        name="Tags"
        :items="tagItems"
        :multiple="true"
        :include-blank="false"
        :initial-selected="selectedTags"
        @change="onTagsChange"
      >
        <i class="tag icon" slot="menuIcon" />
        <span class="text" slot="menuName">{{ tagsLabel }}</span>
        <span slot="label" slot-scope="props">
          <i class="tag icon" />{{ props.item.label }}
        </span>
      </dropdown>
    </div>

    <div class="report-controls-cluster">
      <dropdown
        class="menu-drop button basic floating control-drop"
        name="Group"
        :items="groupOptions"
        :multiple="false"
        :include-blank="false"
        :initial-selected="[groupMode]"
        @change="onGroupChange"
      >
        <i class="layer group icon" slot="menuIcon" />
      </dropdown>

      <dropdown
        class="menu-drop button basic floating control-drop"
        name="Sort"
        :items="sortOptions"
        :multiple="false"
        :include-blank="false"
        :initial-selected="[sortMode]"
        @change="onSortChange"
      >
        <i class="sort amount down icon" slot="menuIcon" />
      </dropdown>
    </div>

    <div class="report-controls-search">
      <div class="ui fluid action input" :class="{ loading: isLoading }">
        <input
          v-model="query"
          type="text"
          class="prompt"
          placeholder="Search"
        />
        <button class="ui icon button">
          <i class="search icon" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ReportFilter from "./filter.vue";
import Dropdown from "components/dropdown.vue";
import { mapState } from "vuex";

export default {
  components: {
    ReportFilter,
    Dropdown,
  },
  props: {
    deliverableTypes: Array,
    selectedDeliverableTypes: Array,
    typeIndex: Object,
    colors: Object,
    tags: {
      type: Array,
      default: () => [],
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
    groupMode: {
      type: String,
      default: "none",
    },
    sortMode: {
      type: String,
      default: "performance:desc",
    },
    groupOptions: {
      type: Array,
      default: () => [],
    },
    sortOptions: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      query: "",
    };
  },
  computed: {
    ...mapState("report", {
      report: "report",
      accessToken: "accessToken",
    }),
    tagItems() {
      return this.tags.map((t) => ({ label: t, value: t }));
    },
    tagsLabel() {
      return this.selectedTags.length
        ? `Tags (${this.selectedTags.length})`
        : "Tags";
    },
  },
  watch: {
    query(val) {
      this.$emit("changeSearchQuery", val);
    },
  },
  methods: {
    reportFilterChanged(value) {
      this.$emit("reportFilterChanged", value);
    },
    onTagsChange(value) {
      this.$emit("tagsChanged", value);
    },
    onGroupChange(value) {
      if (value !== this.groupMode) this.$emit("groupChanged", value);
    },
    onSortChange(value) {
      if (value !== this.sortMode) this.$emit("sortChanged", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.report-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0 1rem;
}

.report-controls-cluster {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.report-controls-cluster .control-drop {
  margin: 0;
}

.report-controls-search {
  margin-left: auto;
  flex: 0 1 320px;
  min-width: 200px;
}

@media (max-width: 991px) {
  .report-controls-search {
    margin-left: 0;
    flex-basis: 100%;
  }
}
</style>
